export default __webpack_public_path__ + "assets/images/Munim-Logo.4e48c641.svg";